import {Generics} from "./generics.ts";
import {SubmissionRequest} from "../models/SubmissionRequest.ts";
import {compute, signal} from "../../fjsc/src/signals.ts";
import {dayFrom, todayWithOffset} from "../functions/dates.ts";
import {create, ifjs} from "../../fjsc/src/f2.ts";
import {FJSC} from "../../fjsc";
import {Inputs} from "./inputs.ts";
import {Api} from "../api/api.ts";
import {notify} from "../functions/notifications.ts";
import {NotificationType} from "../enums/NotificationType.ts";
import {navigate} from "../routing/Router.ts";

export class Submission {
    static page() {
        return Generics.pageFrame(
            create("div")
                .classes("flex-v", "center-items")
                .children(
                    Generics.heading(1, "Submit", ["bold"]),
                    Submission.form()
                ).build()
        );
    }

    static form() {
        const link = signal("");
        const actualLink = compute(l => {
            if (l.includes("soundcloud.com")) {
                return l.split("?")[0];
            }
            return l;
        }, link);
        const desiredReleaseDate = signal(dayFrom(todayWithOffset(90)));
        const artistName = signal("");
        const email = signal("");
        const message = signal("");
        const anyEmpty = compute((l, d, a, e, m) => {
            return l === "" || d === null || a === "" || e === "" || m === "";
        }, actualLink, desiredReleaseDate, artistName, email, message);
        const loading = signal(false);
        const buttonDisabled = compute((a, l) => a || l, anyEmpty, loading);

        return create("div")
            .classes("flex-v", "form-content")
            .children(
                Inputs.url(link, "Link", "link"),
                Inputs.date(desiredReleaseDate, "Desired release date", "desired_release_date"),
                Inputs.text(artistName, "Artist name", "artist_name"),
                Inputs.email(email, "Email", "email"),
                Inputs.longtext(message, "Message", "message"),
                create("div")
                    .classes("flex")
                    .children(
                        FJSC.button({
                            text: "Submit",
                            classes: ["positive"],
                            disabled: buttonDisabled,
                            icon: { icon: "send" },
                            onclick: () => {
                                loading.value = true;
                                Api.submitRelease({
                                    link: actualLink.value,
                                    desiredReleaseDate: desiredReleaseDate.value,
                                    artistName: artistName.value,
                                    email: email.value,
                                    message: message.value,
                                }).then(() => {
                                    notify("Submission sent", NotificationType.success);
                                }).finally(() => {
                                    loading.value = false;
                                    navigate("/submission-success");
                                });
                            }
                        }),
                        ifjs(loading, create("div")
                            .classes("flex", "center-items")
                            .children(
                                create("span")
                                    .text("Submitting")
                                    .build(),
                                Generics.loading(),
                            ).build()),
                    ).build(),
                create("span")
                    .classes("color-dim")
                    .text("Alternatively, you can also submit a release by sending an email to alex @ trirecords.eu")
                    .build()
            ).build();
    }

    static successPage() {
        return Generics.pageFrame(
            create("div")
                .classes("flex-v", "center-items")
                .children(
                    create("h1")
                        .classes("flex", "center-items")
                        .children(
                            create("b").text("Success").build(),
                            Generics.icon("check")
                        ).build(),
                    create("p")
                        .text("Your submission has been received. We will get back to you as soon as possible.")
                        .build()
                ).build()
        );
    }
}